import { IMasterData } from 'api/app.api'
import { queryKeys } from 'queries/queryKeys'
import { useQueryClient } from 'react-query'

export const useMasterData = () => {
  const queryCache = useQueryClient()
  const data = queryCache?.getQueryData<IMasterData>(queryKeys.MASTER_DATA)
  return data
}
